import { render, staticRenderFns } from "./centers-map.vue?vue&type=template&id=324344f8&scoped=true"
import script from "./centers-map.vue?vue&type=script&lang=js"
export * from "./centers-map.vue?vue&type=script&lang=js"
import style0 from "./centers-map.vue?vue&type=style&index=0&id=324344f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324344f8",
  null
  
)

export default component.exports